import { useEffect } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import { AffiliateFormComponent } from '../../components/AffiliateForm'
import { ButtonComponent } from '../../components/Button'
import { LayoutPage } from '../../components/LayoutPage'
import { PageTitleComponent } from '../../components/PageTitleComponent'
import { SpinnerComponent } from '../../components/Spinner'

import { useControlSearchAffiliates } from '../../hooks/useControlSearchAffiliates'
import { useSimpleState } from '../../hooks/useSimpleState'
import { useView } from '../../hooks/useView'

const EditAffiliatePage = () => {
    const { id } = useParams()

    const navigate = useNavigate()

    const { _state } = useSimpleState({
        fetching: false,
        affiliate: null
    })

    const {_state: _errors} = useSimpleState({})

    const {_view: _viewMain} = useView({
        initialView: 'loading',
        views: {
            loading: renderLoading,
            main: renderMain
        }
    })

    const {_control} = useControlSearchAffiliates()

    const fetch = () => {
        _control.fetchGetAffiliate(id).then((res) => {
            if (res.status === 200) {
                _state.set('affiliate', res.body)
            } else {
                navigate('/affiliates')
            }
        }).finally(() => {
            _viewMain.set('main')
        })
    }

    useEffect(() => {
        fetch()
    }, [])

    const handleSubmit = (body) => {
        _state.set('fetching', true)

        _control.fetchEdit(body).then(res => {
            if (res.status === 200) {
                navigate('/affiliates')
            } else {
                _errors.set(res.errors?.errors || {})
            }
        }).finally(() => {
            _state.set('fetching', false)
        })
    }

    const handleDelete = () => {
        _state.set('fetching', true)

        _control.fetchDelete(_state.get('affiliate')).then(() => {
            navigate('/affiliates')
        }).finally(() => {
            _state.set('fetching', false)
        })
    }

    function renderLoading() {
        return (
            <div>
                <SpinnerComponent />
            </div>
        )
    }

    function renderMain() {
        return (
            <div>
                <LayoutPage config={{ id: 'ManageDeals' }}>
                    <div className="manageDeals-header">
                        <PageTitleComponent value="Edit Affiliate" />
                        <ButtonComponent config={{ palette: 'gray' }} events={{ handleClick: handleDelete }}>
                            Delete
                        </ButtonComponent>
                    </div>

                    <div className={_state.get('fetching') ? 'disabled' : ''}>
                        <AffiliateFormComponent value={_state.get('affiliate')} config={{
                            errors: _errors.get(),
                            actionType: 'edit'
                        }} events={{
                            handleSubmit: handleSubmit
                        }} />
                    </div>
                </LayoutPage>
            </div>
        )
    }

    return _viewMain.get()
}

export { EditAffiliatePage }
